export enum PreCheckoutModal {
  OptionSelection = 'optionSelection',
  ValueProposition = 'valueProposition',
  GenericErrorModal = 'genericErrorModal',
  None = 'none',
}
